import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useCollectionsEfficiencyV2({
  branchIds,
  start,
  end,
  tipo,
  enabled = true,
}) {
  const { getCollectionsEfficiency } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "collectionsEfficiencyV2",
      user?.user_id ?? null,
      branchIds,
      start,
      end,
      tipo,
    ],
    queryFn: () =>
      getCollectionsEfficiency({
        branch_id: branchIds,
        start,
        end,
        tipo,
      }),
    enabled: Boolean(enabled && branchIds?.length && start && end && tipo),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
